import { render, staticRenderFns } from "./CardItemSkeleton.vue?vue&type=template&id=52bbbc4b&scoped=true"
import script from "./CardItemSkeleton.vue?vue&type=script&lang=js"
export * from "./CardItemSkeleton.vue?vue&type=script&lang=js"
import style0 from "./CardItemSkeleton.vue?vue&type=style&index=0&id=52bbbc4b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52bbbc4b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VSkeletonLoader})
